import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { useGroupParent } from "./useGroupContext.js";
import { InputWrapper } from "./Input.styles.js";
function InputRow({
  children,
  ...props
}) {
  useGroupParent("InputRow");
  return /* @__PURE__ */ jsx(InputRowStyled, {
    ...props,
    children
  });
}
const InputRowStyled = styled.div.withConfig({
  displayName: "InputRowStyled",
  componentId: "sc-1mba7ih-0"
})(["display:flex;gap:", ";> *:not(", "){min-width:auto;}> ", "{min-width:0;}"], token.spacing4, InputWrapper, InputWrapper);
export {
  InputRow
};
//# sourceMappingURL=InputRow.js.map
